"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isServerError = void 0;
const isServerError = (code) => {
    if (!code)
        return true;
    return [500, 503].includes(code);
};
exports.isServerError = isServerError;
